<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../../utils/UIStore';
import { renderMarkdown } from '../../utils/markdownParser';
import QuellenMetaInfos from './QuellenMetaInfos.svelte';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

function escapeDots(text) {
  /*
        This function escapes dots (.) in certain constellations to prevent rendering as markdown lists
         */

  // Dates

  // Regular expression to match dates in dd.mm.yyyy or dd.Month.yyyy format
  const datePattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/g;

  // Replace the dots in the matched dates with escaped dots
  let escapedText = text.replace(datePattern, '$1\\.$2\\.$3');

  // List of German month names
  const months = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];

  // Join the month names into a regex group
  const monthsRegex = months.join('|');
  const monthRegexPattern = new RegExp(`(\\d{1,2})\\.\\s+(${monthsRegex})`, 'g');
  escapedText = escapedText.replace(monthRegexPattern, '$1\\. $2');

  // xx. Wahlperiode
  const periodRegexPattern = /(\d{1,2})\.(\s*Wahlperiode)/g;
  escapedText = escapedText.replace(periodRegexPattern, '$1\\.$2');

  return escapedText;
}

export let source = { content: '' };

// do some regex magic to escape dots in dates (otherwise it would be rendered as markdown list)
const content = escapeDots(source.content);

//source text toggle mini/maxi
let isMinimized = true;

function toggleClass() {
  isMinimized = !isMinimized;
}
</script>

<div class={isMinimized ? 'minimized' : ''}>
    <button class="show-more" on:click={toggleClass}>
        {#if isMinimized}
            {uiTexts.ragAccordeon.showMore}
        {:else}
            {uiTexts.ragAccordeon.showLess}
        {/if}
    </button>

    {#if isMinimized}
        {@html renderMarkdown(content.replace("\n", " ").replace(/<br\s*\/?>/gi, " "))}
    {:else }
        {@html renderMarkdown(content)}
    {/if}

    <QuellenMetaInfos meta={source.meta}/>

</div>

<style>

    .minimized {
        max-height: 2.25rem;
        overflow: hidden;
        padding-bottom: 1rem;
    }

    button.show-more {
        background: var(--bg-color);
        color: #000;
        border: none;
        position: absolute;
        bottom: 0;
        right: 0;
    }
</style>